import { noop } from 'lodash-es'
import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'

import Checkbox from '@/component/atoms/Checkbox/_Checkbox/_Checkbox'
import { Icon } from '@/component/atoms/Icon'
import { POPUP_OPTION } from '@/constant'
import { MATHFLAT_MODAL_PORTAL } from '@/constant/ui/DOM'
import modalService from '@/service/modal.service'

import S from './Modal.style'

const CommonModal = () => {
  const [isDoNotShowAgainOptionChecked, setIsDoNotShowAgainOptionChecked] = useState(false)
  const checkboxRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    return () => modalService.closeModal()
  }, [])

  return (
    <>
      {modalService.modalList.map((modal, i) => (
        <Modal
          portalClassName={MATHFLAT_MODAL_PORTAL}
          key={`modal-${i}`}
          data-mathflat-unique-id={`modal-${i}`}
          isOpen={true}
          onRequestClose={modal.opt.isCloseable ? modalService.closeModal : noop}
          style={
            modal.opt?.modalStyleTheme === 'common'
              ? {
                  overlay: { ...S.common.overlay, ...modal.opt.modalStyle?.overlay },
                  content: {
                    ...S.common.content,
                    ...modal.opt.modalStyle?.content,
                    ...(modal.opt.modalContentRadius !== undefined && {
                      borderRadius: modal.opt.modalContentRadius,
                    }),
                    ...(modalService.modalOffsetY !== null && {
                      transform: `translateY(${modalService.modalOffsetY}px)`,
                      transition: 'transform 0.2s ease-out',
                    }),
                  },
                }
              : modal.opt?.modalStyleTheme === 'content'
                ? {
                    overlay: { ...S.common.overlay, ...modal.opt.modalStyle?.overlay },
                    content: {
                      ...S.content,
                      ...modal.opt.modalStyle?.content,
                      ...(modal.opt.modalContentRadius !== undefined && {
                        borderRadius: modal.opt.modalContentRadius,
                      }),
                      ...(modalService.modalOffsetY !== null && {
                        transform: `translateY(${modalService.modalOffsetY}px)`,
                        transition: 'transform 0.2s ease-out',
                      }),
                    },
                  }
                : {
                    overlay: { ...S.video.overlay, ...modal.opt.modalStyle?.overlay },
                    content: {
                      ...S.video.content,
                      ...modal.opt.modalStyle?.content,
                      ...(modal.opt.modalContentRadius !== undefined && {
                        borderRadius: modal.opt.modalContentRadius,
                      }),
                      ...(modalService.modalOffsetY !== null && {
                        transform: `translateY(${modalService.modalOffsetY}px)`,
                        transition: 'transform 0.2s ease-out',
                      }),
                    },
                  }
          }
        >
          {modal.opt.hasCloseButton && (
            <button
              style={
                modal.opt.closeButtonCustomStyle
                  ? modal.opt.closeButtonCustomStyle
                  : modal.opt.useCloseButtonOutsideStyle
                    ? S.outsideButtonStyle
                    : S.insidebuttonStyle
              }
              type="button"
              data-testid="modal-close"
              onClick={() => {
                modalService.closeModal()
              }}
            >
              <Icon
                name="close"
                color={modal.opt.closeButtonCustomStyle?.color ?? 'var(--Colors-Gray-700)'}
                size={24}
              />
            </button>
          )}
          {modal.modalContent}

          <div
            css={S.confirmModalOption}
            className={
              modal.opt.closeButtonPlacement && `cta-container__${modal.opt.closeButtonPlacement}`
            }
          >
            {modal.opt.doNotShowAgainOption && (
              <Checkbox
                ref={checkboxRef}
                className="option"
                text={POPUP_OPTION['DO_NOT_SHOW_AGAIN']}
                onChange={(checked) => {
                  setIsDoNotShowAgainOptionChecked(checked)
                  modal.opt.onDoNotShowAgainOptionChange?.(checked)
                }}
              />
            )}
            {modal.opt.hasBottomCloseButton && (
              <button
                className="right-bottom-close-text-button"
                onClick={() => {
                  modalService.closeModal()
                  modal.opt.onClose?.(isDoNotShowAgainOptionChecked)
                }}
              >
                닫기
              </button>
            )}
          </div>
        </Modal>
      ))}
    </>
  )
}

export default observer(CommonModal)
